// Core
import React from 'react';

function Icon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 10 7"
      fill="currentColor"
    >
      <path d="M5 0L10 6H0L5 0Z" />
    </svg>
  );
}

export default Icon;
